import { all, takeEvery } from 'redux-saga/effects'

import { MessagesActions } from '../actions'
import { viewed } from './viewed'

export function* messagesSaga() {
  yield all([takeEvery(MessagesActions.viewed, viewed)])
}
